// extracted by mini-css-extract-plugin
export default {"frame":"ImageEnlargement_frame__Dq2ip","fillFrame":"ImageEnlargement_fillFrame__M2CX0","open":"ImageEnlargement_open__QBZAF","image":"ImageEnlargement_image__-gtF-"};